<template>
  <div class="mod-config" style="height: 100%">
    <div class="list_ul">
      <ul>
        <li @click="getDevices('1')">
          <p style="line-height: 40px;">告警中</p>
          <p style="line-height: 20px;font-size: 20px;">{{ workstatusPro.alarm }}</p>
        </li>
        <li @click="getDevices('2')">
          <p style="line-height: 40px;">待处理</p>
          <p style="line-height: 20px;font-size: 20px;">{{ workstatusPro.pend }}</p>
        </li>
        <li @click="getDevices('3')">
          <p style="line-height: 40px;">历史告警</p>
          <p style="line-height: 20px;font-size: 20px;">{{ workstatusPro.history }}</p>
        </li>
      </ul>
    </div>
    <div style="position: absolute;top: 152px;right: 10px;margin-bottom: 0px;">
      <el-button @click="search()" type="primary" icon="el-icon-search"></el-button>
      <el-button type="success" @click="dealHandle()" :disabled="dataListSelections.length <= 0"
        v-if="this.dataForm.showType == 2">批量处理</el-button>
      <el-button type="primary" @click="ignoreHandle()" :disabled="dataListSelections.length <= 0"
        v-if="this.dataForm.showType == 2">忽略本次</el-button>
      <el-button type="danger" @click="deleteHandle()" :disabled="dataListSelections.length <= 0">批量删除</el-button>
      <el-button type="success" @click="deviceExcel()" v-if="this.dataForm.showType == 3">导出excel</el-button>
    </div>
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="height: 80px;">
      <i class="liat_i" style="background: #FF4D4D;">{{ workstatusProstatus.exceed }}</i>
      <i class="liat_i" style="background: #FBD334;margin-left: 6px;">{{ workstatusProstatus.fault }}</i>
      <i class="liat_i" style="background: #BFB6B6;margin-right: 10px;margin-left: 6px;">{{
        workstatusProstatus.deficiency}}</i>
      <el-form-item style="float: left;" label="处理状态：">
        <template>
          <el-select v-model="dataForm.dealStatus" clearable placeholder="处理状态">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-form-item>
      <el-form-item style="float: left;margin:0px 12px !important" label="告警类型：">
        <template>
          <el-select v-model="dataForm.alarmType" clearable placeholder="告警类型">
            <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-form-item>
      <el-form-item label="设备名称：">
        <el-input v-model="dataForm.deviceName" placeholder="设备名称" clearable
          style="width: calc(100% - 10px);"></el-input>
      </el-form-item>
    </el-form>
    <el-table :data="dataList" v-loading="dataListLoading" @selection-change="selectionChangeHandle"
      style="width: 100%;" height="calc(100% - 260px)" border stripe :header-cell-style="{ background: '#FAFAFA' }"
      placement="top">
      <el-table-column type="selection" header-align="center" align="center" width="50">
      </el-table-column>
      <el-table-column prop="id" header-align="center" align="center" label="告警编号" width="80">
      </el-table-column>
      <el-table-column prop="type" header-align="center" align="center" label="告警类型" width="100">
        <template slot-scope="scope">
          <label v-if="scope.row.type == '2'"><i
              style="display: inline-block;border-radius: 10px;background: #ff410a;padding: 0 10px;font-style: normal;color: #fff;">超标</i></label>
          <label v-if="scope.row.type == '3'"><i
              style="display: inline-block;border-radius: 10px;background: #767a81;padding: 0 10px;font-style: normal;color: #fff;">缺失</i></label>
          <label v-if="scope.row.type == '4'"><i
              style="display: inline-block;border-radius: 10px;background: #E6A23C;padding: 0 10px;font-style: normal;color: #fff;">故障</i></label>
        </template>
      </el-table-column>
      <el-table-column prop="deviceName" header-align="center" align="center" label="设备名称" width="350">
      </el-table-column>
      <el-table-column prop="content" header-align="center" align="center" label="告警内容">
      </el-table-column>
      <el-table-column prop="updateTime" header-align="center" align="center" label="首次告警时间" width="180" sortable>
      </el-table-column>
      <el-table-column prop="alarmTime" header-align="center" align="center" label="告警结束时间" width="180">
        <template slot-scope="scope">
          <label v-if="scope.row.alarmTime == null || scope.row.alarmTime == ''"><i
              style="display: inline-block;font-style: normal;">至今</i></label>
          <label v-else><i style="display: inline-block;font-style: normal;">{{ scope.row.alarmTime }}</i></label>
        </template>
      </el-table-column>
      <el-table-column prop="dealStatus" header-align="center" align="center" label="处理状态" width="100">
        <template slot-scope="scope">
          <label v-if="scope.row.dealStatus == '0'"><i style="display: inline-block;font-style: normal;">告警中</i></label>
          <label v-if="scope.row.dealStatus == '1'"><i style="display: inline-block;font-style: normal;">待处理</i></label>
          <label v-if="scope.row.dealStatus == '2'"><i style="display: inline-block;font-style: normal;">已忽略</i></label>
          <label v-if="scope.row.dealStatus == '3'"><i style="display: inline-block;font-style: normal;">已处理</i></label>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="操作" width="120">
        <template slot-scope="scope">
          <!--          <el-button  @click="dealHandle(scope.row.id)" :disabled="scope.row.dealStatus != '1'" size="mini" type="danger" v-if="scope.row.dealStatus == '1'">-->
          <!--            <span class="edit-btn">处理</span>-->
          <!--          </el-button>-->
          <img src="../../assets/img/alarm_2.png" alt="" @click="handleIgnore(scope.row)" width="24" height="24"
            style="cursor: pointer;" v-if="scope.row.dealStatus == '1'">
          <img src="../../assets/img/alarm_1.png" alt="" @click="handleModify(scope.row.id)" width="24" height="24"
            style="cursor: pointer;" v-if="scope.row.dealStatus == '3'">
          <img src="../../assets/img/alarm_del.png" alt="" @click="deleteHandle(scope.row.id)" width="24" height="24"
            style="cursor: pointer;">
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
      layout="prev, pager, next, jumper, total,sizes">
    </el-pagination>
    <!--  处理&&忽略  -->
    <el-dialog :visible.sync="evaluated" :modal-append-to-body="false" :close-on-click-modal="false" width="30%" class="gjcl">
      <lable style="font-size: 20px;margin-bottom: 20px;display: inline-block;">请选择
        {{ this.type }}-{{ this.deviceName }}的处理方式
      </lable>
      <el-form style="width: 100%;display: block;font-size: 20px;" :model="form">
        <el-form-item>
          <!--          <label style="font-size: 20px;">处理方式</label>-->
          <el-radio-group v-model="form.resource" @change="changeReportLevel">
            <el-radio label="2" style="font-size: 20px;">忽略</el-radio>
            <span
              style="display: inline-block;height: auto;padding-bottom: 20px;color: #000;line-height: 30px;font-size: 20px;">选择忽略本次操作后，该告警状态将更新为已忽略，当相同告警再次发生时，系统将再次告警。</span>
            <el-radio label="1" style="font-size: 20px;">处理</el-radio>
            <label style="font-size: 20px;display: block;line-height: 40px;">处理结果：</label>
            <el-input type="textarea" v-model="form.desc" style="height: 200px;" :disabled="form.bled"></el-input>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="evaluated = false">取 消</el-button>
        <el-button type="primary" @click="btn_evaluated">确 定</el-button>
      </div>
    </el-dialog>
    <!--  处理  -->
    <el-dialog title="查看处理结果" :visible.sync="evaluate" :modal-append-to-body="false" :close-on-click-modal="false"
      width="30%" height="300" style="top: 10%;text-align: left;font-size: 28px;">
      <el-form style="width: 100%;display: block;font-size: 20px;" :model="form">
        <el-form-item>
          <label style="font-size: 20px;">处理方式</label>
          <p style="font-size: 20px;display: inline-block;padding-left: 20px;">处理</p>
        </el-form-item>
        <el-form-item>
          <label style="font-size: 20px;">处理结果：</label>
          <el-input type="textarea" v-model="form.desc" style="height: 200px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="evaluate = false">取 消</el-button>
        <el-button type="primary" @click="btn_evaluate">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<style scoped>
@import '../../assets/css/indexhome.css';
/deep/ el-dialog__header{
  height: 30px;
}
.list_ul {
  height: 100px;
  border: 1px solid #ebeef5;
  padding: 10px;
}

.list_ul ul {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: baseline;
  -ms-flex-align: baseline;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
  height: 100%;
}

.list_ul ul li {
  width: 130px;
  float: left;
  color: #fff;
  margin: 0 10px;
  cursor: pointer;
  height: 70px;
  border-radius: 6px;
  padding: 0 20px;
}

.list_ul ul li:nth-child(1) {
  background: rgb(255, 121, 112);
}

.list_ul ul li:nth-child(2) {
  background: #E6A23C;
}

.list_ul ul li:nth-child(3) {
  background: #85ce61;
}

.el-form--inline .el-form-item {
  margin: 0 !important;
}

.mod-config form {
  justify-content: initial;
}

.liat_i {
  display: inline-block;
  font-style: inherit;
  width: 42px;
  height: 32px;
  color: #fff;
  text-align: center;
  line-height: 32px;
  font-size: 18px;
}

/deep/ .el-textarea__inner {
  height: 200px !important;
}

/deep/ .el-radio__label {
  font-size: 20px !important;
}

/deep/ .el-radio__inner {
  zoom: 1.7;
}
</style>
<script>
import { excel, isAuth } from "@/utils";
export default {
  data() {
    return {
      deviceName: '',
      type: '',
      value1: '',
      form: {
        desc: '',
        resource: '',
        bled: true
      },
      dataForm: {
        alarmType: '',
        dealStatus: '',
        showType: '1',
        dateFromStr: '',
        dateToStr: '',
        deviceName: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      statusOptions: [],
      typeOptions: [{ value: 2, label: "超标" }, { value: 3, label: "缺失" }, { value: 4, label: "故障" }],
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      workstatusPro: {},
      workstatusProstatus: {},
      evaluated: false,
      evaluate: false,
      evaluate_id: [],
      handleIgnorevalue: ''
    }
  },
  created() {
    this.getDataList()
    this.statusPro()
    this.getStatusOption()
  },
  methods: {
    //工单状态
    statusPro() {
      this.$http({
        url: this.$http.adornUrl('/alarm/statusPro'),
        method: 'get',
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.workstatusPro = data.data
        }
      })
    },
    //搜索
    search() {
      this.dataForm.showType = ''
      this.pageIndex = 1;
      this.getDataList()
    },
    // 获取数据列表
    getDataList() {
      if (this.dataForm.dateStr) {
        this.dataForm.dateFromStr = this.dataForm.dateStr[0];
        this.dataForm.dateToStr = this.dataForm.dateStr[1];
      }
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('alarm/list'),
        method: 'get',
        params: this.$http.adornParams({
          'pageNum': this.pageIndex,
          'pageSize': this.pageSize,
          'deviceName': this.dataForm.deviceName,
          'type': this.dataForm.alarmType,
          'dealStatus': this.dataForm.dealStatus,
          showType: this.dataForm.showType,
          dateFromStr: this.dataForm.dateFromStr,
          dateToStr: this.dataForm.dateToStr,
        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.dataList = data.data.rows
          this.totalPage = data.data.total
          this.workstatusProstatus = data.data.status[0]
          //重置参数
          this.dataForm.dateFromStr = '';
          this.dataForm.dateToStr = '';
        } else {
          this.dataList = []
          this.totalPage = 0
          this.$message.error(data.msg)
        }
        this.dataListLoading = false
      })
    },
    //设备总数
    getDevices(event) {
      this.dataForm.showType = event
      this.pageIndex = 1
      this.getDataList()
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    // 忽略本次
    ignoreHandle(id) {
      let ids = id ? [id] : this.dataListSelections.map(item => {
        return item.id
      })
      // this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
      this.$confirm(`确定要忽略所选告警信息`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/alarm/ignore'),
          method: 'post',
          data: this.$http.adornData(ids, false)
        }).then(({ data }) => {
          if (data && data.code === 200) {
            this.getDataList()
            this.statusPro();
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    //批量处理
    dealHandle(id) {
      let ids = id ? [id] : this.dataListSelections.map(item => {
        return item.id
      })
      // this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
      this.$confirm(`确定要将所选告警信息设置为已处理`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('alarm/deal'),
          method: 'post',
          data: this.$http.adornData({
            'ids': ids,
            'dealContent': '',
          })
        }).then(({ data }) => {
          if (data && data.code === 200) {
            this.getDataList()
            this.statusPro();
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    //批量删除
    deleteHandle(id) {
      let ids = id ? [id] : this.dataListSelections.map(item => {
        return item.id
      })
      // this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
      this.$confirm(`确定要删除所选告警信息`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/alarm/delete'),
          method: 'post',
          data: this.$http.adornData(ids, false)
        }).then(({ data }) => {
          if (data && data.code === 200) {
            this.getDataList()
            this.statusPro();
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    //导出
    deviceExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      excel("/alarm/excel", "历史告警信息-" + this.$moment(new Date()).format("yyyyMMDDHHmm"), {
        'pageNum': this.pageIndex,
        'pageSize': this.pageSize,
        'params': this.dataForm.params,
      }, loading.close(), this.$message({
        message: '导出成功',
        type: 'success',
        duration: 3000,
        showClose: true,
        onClose: () => { }
      })
      )
    },
    // 处理
    handleModify(id) {
      this.evaluate = true;
      this.form.desc = '';
      this.evaluate_id = [id];
      this.$http({
        url: this.$http.adornUrl("alarm/list?id=" + this.evaluate_id),
        method: 'get',
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.form.desc = data.data.rows[0].dealContent
        }
      })
    },
    btn_evaluate() {
      this.$http({
        url: this.$http.adornUrl('alarm/deal'),
        method: 'post',
        data: this.$http.adornData({
          'ids': this.evaluate_id,
          'dealContent': this.form.desc,
        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.getDataList()
          this.statusPro();
          this.$message({
            message: data.msg,
            type: 'success',
            duration: 1000,
          })
          this.evaluate = false;
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    handleIgnore(id) {
      this.evaluated = true;
      this.form.bled = true;
      this.form.resource = ''
      this.form.desc = '';
      this.evaluate_id = [id.id];
      this.deviceName = id.deviceName
      if (id.type == 2) {
        this.type = '超标'
      } else if (id.type == 3) {
        this.type = '缺失'
      } else if (id.type == 4) {
        this.type = '故障'
      }
    },
    changeReportLevel(value) {
      this.handleIgnorevalue = value;
      if (value == 1) {
        this.form.bled = false;
      } else if (value == 2) {
        this.form.bled = true;
      }
    },
    btn_evaluated() {
      if (this.handleIgnorevalue == 1) {
        this.$http({
          url: this.$http.adornUrl('alarm/deal'),
          method: 'post',
          data: this.$http.adornData({
            'ids': this.evaluate_id,
            'dealContent': this.form.desc,
          })
        }).then(({ data }) => {
          if (data && data.code === 200) {
            this.getDataList()
            this.statusPro();
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
            this.evaluated = false;
          } else {
            this.$message.error(data.msg)
          }
        })
      } else if (this.handleIgnorevalue == 2) {
        this.$http({
          url: this.$http.adornUrl('alarm/ignore'),
          method: 'post',
          data: this.$http.adornData(this.evaluate_id, false)
        }).then(({ data }) => {
          if (data && data.code === 200) {
            this.getDataList()
            this.statusPro();
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
            this.evaluated = false;
          } else {
            this.$message.error(data.msg)
          }
        })
      } else {
        this.evaluated = false;
      }
    },
    //获取处理状态
    getStatusOption() {
      this.$http({
        url: this.$http.adornUrl("/configOption/option/18"),
        method: 'get'
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.statusOptions = data.data.enumOption
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/handlecenter/deviceAlarm.vue